import * as Yup from "yup";

export const forgotPasswordSchema = Yup.object().shape({
  email: Yup.string()
    .email("Must Enter Valid Email")
    .required("Must Enter Email Address"),
});
